module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.stockLoaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pricingTable != '' && _vm.stockLoaded == true) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pricingTable != '' && _vm.stockLoaded == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncUpdateStock
    }
  }, [_vm._v("Update Stock")])], 1) : _vm._e(), _vm._v(" "), (_vm.pricingTable != '' && _vm.stockLoaded == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncDownloadCsv
    }
  }, [_vm._v("Download CSV")])], 1) : _vm._e(), _vm._v(" "), (_vm.pricingTable != '' && _vm.stockLoaded == true) ? _c('v-flex', {
    staticStyle: {
      "padding-left": "1%"
    },
    attrs: {
      "lg2": ""
    }
  }, [_c('small', {
    staticStyle: {
      "font-size": "10px",
      "display": "block",
      "clear": "both"
    }
  }, [_vm._v("Bulk Upload")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-top": "0px",
      "width": "200px",
      "display": "block",
      "float": "left"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "input": _vm.fncSetStock
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.stockLoaded == true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v("Please select a pricing table to update the stock levels for:")])]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.pricingTables,
      "placeholder": "Select Pricing Table",
      "item-value": "pricing_table",
      "item-text": "pricing_table",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": _vm.fncShowDataTable
    },
    model: {
      value: (_vm.pricingTable),
      callback: function($$v) {
        _vm.pricingTable = $$v
      },
      expression: "pricingTable"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pricingTable != '' && _vm.stockLoaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "rows-per-page-items": [100000],
      "id": "stockTable",
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.codesList
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.code))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('v-text-field', {
          staticStyle: {
            "width": "80%",
            "display": "inline-block",
            "float": "left"
          },
          attrs: {
            "solo": "",
            "single-line": ""
          },
          model: {
            value: (props.item.new_quantity),
            callback: function($$v) {
              _vm.$set(props.item, "new_quantity", $$v)
            },
            expression: "props.item.new_quantity"
          }
        }), _c('span', {
          staticStyle: {
            "float": "left",
            "margin-left": "1%",
            "padding-top": "10px",
            "display": "inline-block"
          }
        }, [_vm._v(_vm._s(props.item.uom))])], 1)]
      }
    }], null, false, 3666645983)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}